//? Dto

import { z } from "zod";
import { apiListSchema } from "./list";

export const CreateDepartmentDtoSchema = z.object({
  Name: z.string(),
  Description: z.string().nullish(),
});

export type CreateDepartmentDto = z.infer<typeof CreateDepartmentDtoSchema>;

export const DepartmentDtoSchema = CreateDepartmentDtoSchema.extend({
  Id: z.number(),
});

export type DepartmentDto = z.infer<typeof DepartmentDtoSchema>;

export const departmentDtoListSchema = apiListSchema(DepartmentDtoSchema);

//? Model
export const CreateDepartmentSchema = z.object({
  name: z.string().min(1),
  description: z.string().nullish(),
});

export const DepartmentSchema = CreateDepartmentSchema.extend({
  id: z.string().min(1),
});

export type CreateDepartment = z.infer<typeof CreateDepartmentSchema>;

export type Department = z.infer<typeof DepartmentSchema>;

//? Mappers
export function departmentFromDto(dto: DepartmentDto): Department {
  return {
    id: dto.Id.toString(),
    name: dto.Name,
    description: dto.Description ?? "",
  };
}

export function departmentToDto(dto: Department): DepartmentDto {
  return {
    Id: Number.parseInt(dto.id),
    ...createDepartmentToDto(dto),
  };
}

export function createDepartmentToDto(
  dto: CreateDepartment,
): CreateDepartmentDto {
  return {
    Name: dto.name,
    Description: dto.description,
  };
}
